var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoOutros(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "67px",
    height: "66px",
    viewBox: "0 0 67 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Outros_65") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outros_65",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#00A9FD",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.27625,22.1235625 L49.6608125,16.2638125 C48.849125,13.8295625 46.570875,12.1875 44.005,12.1875 L27.625,12.1875",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.375,38.1875 L41.5285,38.1875",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.375,44.159375 L46.3149375,44.159375 L46.3149375,48.134125 C46.3149375,49.231 47.204625,50.1206875 48.3023125,50.1206875 L56.251,50.1206875 C57.3486875,50.1206875 58.238375,49.231 58.238375,48.134125 L58.238375,42.612375 C59.4498125,41.5211875 60.22575,39.9563125 60.22575,38.1980625 L60.22575,35.046375 C60.22575,33.2466875 59.51075,31.5209375 58.238375,30.2485625 L58.238375,28.262 L62.213125,26.95875 C63.31,26.95875 64.1996875,26.0690625 64.1996875,24.971375 L64.1996875,22.299875 C64.1996875,21.2021875 63.31,20.3125 62.213125,20.3125 L56.251,20.3125 C55.586375,20.3125 50.227125,26.274625 46.3149375,26.274625 L24.375,26.274625",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.99125,30.875 C50.548875,32.9460625 47.913125,33.281625 44.6875,33.281625",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8236875,44.6875 L46.3125,44.6875",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5853906,0 L14.5853906,11.8616875 L5.85345312,11.8616875 L5.85345312,0.004875 C4.82076562,0.494 3.84901562,1.15375 2.99507812,2.0085 C-0.998359375,6.001125 -0.998359375,12.475125 2.99507812,16.4685625 C3.84901562,17.3225 4.82076562,17.9830625 5.85345312,18.471375 L5.85345312,59.4026875 L5.86970312,59.4026875 C5.86970312,60.5158125 6.29464062,61.6289375 7.14370312,62.478 C8.84264062,64.1769375 11.5970156,64.1769375 13.2951406,62.478 C14.1450156,61.6289375 14.5691406,60.5158125 14.5691406,59.4026875 L14.5853906,59.4026875 L14.5853906,18.47625 C15.6221406,17.987125 16.5979531,17.32575 17.4551406,16.4685625 C21.4485781,12.475125 21.4485781,6.001125 17.4551406,2.0085 C16.5979531,1.1513125 15.6221406,0.489125 14.5853906,0 Z",
    id: "Stroke-11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoOutros);
export default __webpack_public_path__ + "static/media/PictoOutros.2365216f3f841a8ce96f4d36ce3a9880.svg";
export { ForwardRef as ReactComponent };